import { render, staticRenderFns } from "./DepartmentReportTable.vue?vue&type=template&id=91da2cfc&scoped=true&"
import script from "./DepartmentReportTable.vue?vue&type=script&lang=js&"
export * from "./DepartmentReportTable.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentReportTable.vue?vue&type=style&index=0&id=91da2cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91da2cfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
